export default {

  'ajax': (method, uri, data, headers, content_type) => {
    method = method || 'GET';
    uri = uri || '';
    data = data || {};
    headers = headers || [];
    content_type = content_type || 'application/json';
    return new Promise((resolve, reject) => {
      const xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function() {
        if (!((this.readyState == 1) || (this.readyState == 2) || (this.readyState == 3))) {
          let response;
          try {
            response = JSON.parse(this.response);
          } catch (e){
            response = {"response": this.response};
          }
          const success = ((this.readyState == 4) && (this.status >= 200) && (this.status < 300));
          success ? resolve({'status': this.status, response}) : reject({'status': this.status, response});
        }
      };
      xhttp.open(method, uri, true);
      xhttp.setRequestHeader('Content-type', content_type);
      headers.forEach(function (header) {
        if (header['value'] !== null){
          xhttp.setRequestHeader(header['name'], header['value']);
        }
      });
      xhttp.send(data ? JSON.stringify(data) : null);
    });
  }

};